function CounterButton({ onClick, children }) {
  return (
    <button
      type="button"
      className="btn-transparent add-on-counter-button bg-lighter-gray"
      onClick={onClick}
    >
      {children}
    </button>
  );
}

export default CounterButton;
